import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import { userData } from 'mocks/mockData/userData';

export const userDataHandler: RestHandler[] = [
  rest.get(PATHS.getAccountingUserData(), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(userData))
  ),
  rest.get(
    `${PATHS.getAccountingUserData()}/includeStatuses?statuses=*`,
    (_, res, ctx) => res(ctx.status(200), ctx.json(userData))
  )
];
